import AsyncStorage from "@react-native-community/async-storage";
import React, { useCallback, useEffect, useState } from "react";
import { Dimensions, View } from "react-native";

import { Feature } from "ol";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";
import { getDistance } from "ol/sphere";
import { RFeature, RGeolocation, RLayerVector, RMap, RStyle } from "rlayers";

import FlashMessage from "react-native-flash-message";
import PopUpInicial from "../PopUps/PopUpMapaInicial";
import PopUpMapaHistoria from "../PopUps/PopUpMapaHistoria";

import PopUpFinal from "../PopUps/PopUpFinal";
import * as Location from "expo-location";
import PoisMapa from "./Pois";
import RenderLayout from "./Layouts";
import { getRecursURL } from "../../Functions/getRecurs";
import { useFocusEffect } from "@react-navigation/native";
import Loading from "../../components/Loading";
import Menu from "../menu";

/*
    llibreria de mapa https://mmomtchev.github.io/rlayers/api/
*/

function Mapa(RouterData) {
  const { itinerari, currentItinerari, recursos, idioma, projecte } =
    RouterData.route.params;


  const [location, setLocation] = useState(fromLonLat([2.452541, 42.12033])); //fromLonLat([1.6725558042526245,41.20839165286224])
  const [pointLocation, setPointLocation] = useState(
    fromLonLat([2.452541, 42.12033]),
  ); //fromLonLat([1.6725558042526245,41.20839165286224])
  const [width, setWidth] = useState(Dimensions.get("window").width);
  const [height, setHeight] = useState(Dimensions.get("window").height * 0.899);
  const [loaded, setLoaded] = useState(false);
  const [ModalIniciVisible, setModalIniciVisible] = useState(true);
  const [ModalHistoria, setModalHistoria] = useState(false);
  const [ModalFinal, setModalFinal] = useState(true);
  const [features, setFeatures] = useState([]);
  const [currentPoi, setCurrentPoi] = useState(null);
  /*Token per el popUpFinal i altres peticions per analitiques */
  const [token, setToken] = useState("");
  const [angle, setAngle] = useState(0);
  const [deviceOrientation, setDeviceOrientation] = useState(null);

  const poi = itinerari.pois.find((e) => e.id == currentPoi);

  window.addEventListener("resize", () => {
    setWidth(Dimensions.get("window").width);
    setHeight(Dimensions.get("window").height * 0.899);
  });

  // get devuice absolute orientation
  // window.addEventListener('deviceorientationabsolute', (e) => {
  //     console.log('====================================');
  //     console.log(e.alpha);
  //     console.log('====================================');
  //     setDeviceOrientation(e.alpha);
  // });

  useEffect(() => {
    AsyncStorage.getItem("token").then((token) => {
      if (token) {
        setToken(token);
      }

      if (currentItinerari.comencat) {
        setModalIniciVisible(false);
      }

      // Gyroscope.setUpdateInterval(10000);
      // Gyroscope.addListener(gyroscopeData => {
      //     console.log(gyroscopeData);
      // });
    });
  }, []);

  useFocusEffect(
    useCallback(() => {
      const init = async () => {
        await Location.enableNetworkProviderAsync();

        const { status } = await Location.requestForegroundPermissionsAsync();

        if (status !== "granted") {
          console.log("Permission to access location was denied");

          alert(
            "No has habilitat els permisos per accedir la localització. Torna a intentar-ho",
          );
          return;
        }

        const location2 = await Location.getCurrentPositionAsync({});
        setLocation(
          fromLonLat([location2.coords.longitude, location2.coords.latitude]),
        );
        // setAngle(getAngleCompass(currentItinerari.pois,[location2.coords.longitude, location2.coords.latitude],currentItinerari.currentOrder));
      };

      init();

      initMapa();

      return () => {
        setLoaded(false);
      };
    }, [currentItinerari]),
  );

  const initMapa = async () => {
    const features = currentItinerari.pois.map((element) => {
      return new Feature({
        geometry: new Point(
          fromLonLat([
            parseFloat(element.location[0]),
            parseFloat(element.location[1]),
          ]),
        ),
        uid: element.id,
        name: element.Nom,
        id: element.id,
      });
    });

    setFeatures(features);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 500);
  }, [features]);

  const activarPoi = (poi) => {
    setCurrentPoi(poi.id);

    setModalHistoria(true);
    clearInterval(checkPoiAprop);

    poi.popUpLoaded = true;
  };

  const checkPoiAprop = setInterval(() => {
    currentItinerari.pois.forEach((poi) => {
      if (poi.done) {
        return;
      }

      if (poi.order == currentItinerari.currentOrder && !poi.popUpLoaded) {
        const distance = getDistance(
          [parseFloat(poi.location[0]), parseFloat(poi.location[1])],
          location,
        );
        const distanciaActivacio =
          itinerari.pois.find((e) => e.id == poi.id).metresActivacio || 20;

        if (distance <= distanciaActivacio) {
          activarPoi(poi);
        }
      }
    });
  }, 2000);

  const _renderTrackPosition = () => {
    return (
      <RGeolocation //=> d'aquesta manera s'evita el hack de pokemon go (flaying)
        tracking={true}
        trackingOptions={{
          enableHighAccuracy: true,
          maximumAge: 2000,
          timeout: 5000,
        }}
        onChange={(e) => {
          setPointLocation(
            fromLonLat([e.target.position_[0], e.target.position_[1]]),
          ); // per posicionar el punt
          setLocation(e.target.position_); // per posicionar el mapa
        }}
      />
    );
  };

  const renderPopUpInicial = () => {
    return !currentItinerari.comencat
      ? PopUpInicial(RouterData, ModalIniciVisible, setModalIniciVisible)
      : null;
  };

  const renderPopUpHistoria = () => {
    console.log("renderPopUpHistoria", ModalHistoria, !ModalIniciVisible);
    if (ModalHistoria && !ModalIniciVisible) {
      if (poi.teHistoria) {
        return PopUpMapaHistoria(
          RouterData,
          poi,
          ModalHistoria,
          setModalHistoria,
        );
      }
      return null; // PopUpMapa(RouterData, poi, ModalHistoria, setModalHistoria);
    }
    return null;
  };

  const renderPopUpFinal = () => {
    return currentItinerari.finalitzat
      ? PopUpFinal(RouterData, ModalFinal, setModalFinal, token)
      : null;
  };

  if (!loaded) {
    return <Loading />;
  }

  return (
    <View style={{ flex: 1, backgroundColor: projecte.colorPrincipal2 }}>
      {renderPopUpInicial()}
      {renderPopUpHistoria()}
      {renderPopUpFinal()}

      <View>
        <RMap
          width={width}
          height={height}
          initial={{ center: location, zoom: 15 }}
          maxZoom={20}
          noDefaultControls={true}
        >
          {RenderLayout(RouterData)}

          <RLayerVector zindex={10}>
            <RStyle.RStyle>
              <RStyle.RIcon
                src={getRecursURL(recursos, "geolocalitzacio", idioma)}
                scale={0.08}
              />
            </RStyle.RStyle>
            <RFeature geometry={new Point(pointLocation)} />
          </RLayerVector>

          {_renderTrackPosition()}

          {PoisMapa(RouterData, features, location, activarPoi)}
        </RMap>
        <FlashMessage position="top" />
      </View>
      <View style={{ flex: 10 }}>
        <Menu projecte={RouterData.route.params}></Menu>

      </View>
    </View>
  );
}

export default Mapa;

// {PopUpInicial(RouterData)}
// {PopUpMapa(RouterData,itinerari.pois[0])}
// {PopUpMapaHistoria(RouterData,itinerari.pois[0])}
// {PopUpFinal(RouterData)}
